<!--
 * @Author: zhengxiaoxiao
 * @Date: 2020-08-12 15:55:43
 * @Description: 
-->
<template>
	<div class="main-wrap" id="mainWrap">
		<KHeader :scrollTop="scrollTop" :scrollFlag="scrollFlag"></KHeader>
		<div class="content">
			<RouterView :scrollFlag="scrollFlag"></RouterView>
		</div>
		<KFooter></KFooter>
		<KBacktop :show="showBackTop"></KBacktop>
	</div>
</template>

<script>
import KHeader from '../components/kllk-header-nav'
import KFooter from '../components/kllk-footer-nav'
import KBacktop from '../components/kllk-backtop.vue'
import { throttle } from 'throttle-debounce'

export default {
	name: 'HelloWorld',
	components: { KHeader, KFooter, KBacktop },
	data() {
		return {
			scrollTop: true,
			showBackTop: false,
			scrollFlag: true, //导航条显示
		}
	},
	created() {
        this.scrollTop = this.$route.path === '/home'
	},
	mounted() {
		this.throttledScrollHandler = throttle(300, this.onScroll)
		window.addEventListener('scroll', this.throttledScrollHandler)
	},
	methods: {
		onScroll() {
			const scrollTop = this.$el.scrollTop
			if (this.$route.path === '/home') {
				let bannerHeight = document.getElementsByClassName('el-carousel__container')[0].clientHeight;
                this.scrollTop = scrollTop <= 5
                // 首页滚动到banner后，显示首页内部导航
				this.scrollTopHeight =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop
				if (this.scrollTopHeight >= bannerHeight) {
					this.scrollFlag = false
				} else {
					this.scrollFlag = true
				}
			}
			this.showBackTop = scrollTop >= 100
		},
	},
	watch: {
		$route(n) {
			this.$el.scrollTop = 0
            this.scrollTop = this.$route.path === '/home'
		},
	},
	beforeDestroy() {
		this.$el.removeEventListener('scroll', this.throttledScrollHandler)
	},
}
</script>

<style lang="less" scoped>
@import '../style/constant.less';

    .main-wrap {
        overflow: auto;
        height: 100%;

	.content {
		margin-top: 70px;
		min-height: 90vh;
	}
}
</style>
